// extracted by mini-css-extract-plugin
module.exports = {"filter":"orders-page-filter__1-kRg"};